import React, { Component } from "react";
import DeckBuilderMain from "./DeckBuilderComponents/DeckBuilderMain";

class Cards extends Component {
  render() {
    return (
      <React.Fragment>
        <DeckBuilderMain width="100%"/>
      </ React.Fragment>
    );
  }
}

export default Cards;



// WEBPACK FOOTER //
// ./src/Cards.js